import { DictionaryCurrencyList as DictionaryCurrencyListDefinition } from "./DictionaryCurrencyList";

export const DictionaryCurrencyList = DictionaryCurrencyListDefinition;
